
import 'react-toastify/dist/ReactToastify.css';
import './app.scss';
import React, { useEffect, createContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Router } from 'react-router-dom';
import { UserAgent } from 'react-useragent';

import AppRoutes from 'app/routes';
import history from './history';

import { getAppStylesFromCms, getMarketingCampaignContentFromCms } from './modules/cms/service/cms-service';
import { getProductCodeAndConfig } from './modules/config/service/config.service';
import { updateContainerId } from './modules/gtm/service/gtm.service';
import { globalError } from './shared/error/error-global';
import { useErrorHandler } from './shared/components/react-error-boundary';
import { AppError } from './shared/util/error-utils';
import { didomiConfig } from './shared/config/didomi';
import { DidomiSDK } from '@didomi/react';
import { IRootState } from './shared/reducers';
import Helmet from 'react-helmet';
import { isNull } from 'lodash';
import { fetchOfferDocuments, processOfferDocuments } from './modules/corporate/service/corporate.service';
export const IsMobile = createContext(null)

export const DidomiContext = React.createContext(null);

export const App = () => {

  const dispatch = useDispatch();

  const noticeIdDidomi = useSelector((state: IRootState) => state.config.noticeIdDidomi);
  const productCode = useSelector((state: IRootState) => state.config.productCode);
  const selectedOffer = useSelector((state: IRootState) => state.offers.selectedOffer)
  const publicKeyDidomi = useSelector((state: IRootState) => state.config.publicKeyDidomi);
  const isReadyConfigStore = useSelector((state: IRootState) => state.config.isReady)
  const title = useSelector((state: IRootState) => state.config.title);

  const offerCode = useSelector((state: IRootState) => state.config.offerCode);
  const documents = useSelector((state: IRootState) => state.corporate.offerDocuments.documentsByOffer);

  const [didomiObject, setDidomiObject] = useState(null);

  const [error, setError] = React.useState<AppError>()
  useErrorHandler(error);

  useEffect(() => {
    // get Global Config
    dispatch(getProductCodeAndConfig())
    // TODO:  SET DEFAULT LANGUAGE
    if (!localStorage.getItem('language'))
      localStorage.setItem('language', 'FR');
    // Get the marketing content from the CMS
    dispatch(getAppStylesFromCms())
    dispatch(getMarketingCampaignContentFromCms())

    // Store the GTM container id in the state
    dispatch(updateContainerId());

    const _error = globalError.subscribe((msg) => {
      setError(msg.error);
    });

    return () => {
      _error.unsubscribe();
    }

  }, []);



  // useEffect(() => {
  //   if (offerCode)
  //     dispatch(fetchOfferDocuments(offerCode))
  // }, [offerCode])

  // Store offerDocuments urls (NI,  IPID)
  useEffect(() => {
    if (productCode)
      dispatch(processOfferDocuments(productCode, offerCode));
  }, [productCode])


  const onDidomiReady = didomi => {
    setDidomiObject(didomi);
  };

  return (
    <UserAgent>
      {({ ua }) => {
        return (
          <IsMobile.Provider value={ua.mobile}>
            <DidomiContext.Provider value={didomiObject}>
              <Helmet>
                <title>{title}</title>
              </Helmet>
              <Router history={history}>
                <AppRoutes />
                {isReadyConfigStore && productCode && <DidomiSDK
                  config={didomiConfig(publicKeyDidomi, productCode)}
                  iabVersion={2} // If you want to support the TCF v1∏, don't forget to change this value, even if you selected the TCF v2 in the console. This parameter will load the correct stub in the React Component
                  noticeId={noticeIdDidomi} // If you want to target the notice by ID and not by domain
                  gdprAppliesGlobally={true}
                  sdkPath="https://sdk.privacy-center.org/"
                  embedTCFStub={true}
                  onReady={onDidomiReady}
                />}
              </Router>
            </DidomiContext.Provider>
          </IsMobile.Provider>
        )
      }}
    </UserAgent>
  );
};

export default App;
